module.exports = __webpack_public_path__ + "img/catering_menu_10.00ee9d34.jpg";